const InlineLoader = () => {
    return (
        <div className="inline-loader-component">
          <div class="inline-loader"><div></div><div></div><div></div><div></div></div>
        </div>
    );
}
 
export default InlineLoader;